import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { clearMessage, getTemplateStart, resetState, updateTemplateStart } from "../../../Store/Slices/templateSlice";
import Loader from "../../../Components/Loader";
import { Utils } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import { FaPencil } from "react-icons/fa6";
import { formatDateTime } from "../../../Components/DateFn";
import { Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Toast from "../../../Components/Toast";
import { getItem } from "../../../Services/localService";
import { FiSearch } from "react-icons/fi";

const TemplateList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let orgId = getItem('organization')
    let templateData = useSelector((state) => state?.template);
    let [selectedTemplate, setSelectedTemplate] = useState('Quotes');
    // let quoteId = '67a490f319cf00b316d06b37'
    // let soId = '67a490f319cf00b316d06b38'
    let [quoteId, setQuoteId] = useState('')
    let [soId, setSoId] = useState('')
    let [invId, setInvId] = useState('')
    let [value, setValue] = useState('');
    let [templateType] = useState(
        [{ key: 'Quotes', path: 'quote' },
        { key: 'Sales Orders', path: 'sales-order' },
        { key: 'Invoices', path: 'invoice' }
        ])
    let [activePath, setActivePath] = useState('quote')
    let [defaultTemplate, setDefaultTemplate] = useState('')

    let navbarList = useSelector((state) => state?.forms)?.navbarList;

    useEffect(() => {
        if (selectedTemplate === 'Quotes')
            if (quoteId)
                dispatch(getTemplateStart(quoteId))
        if (selectedTemplate === 'Sales Orders')
            if (soId)
                dispatch(getTemplateStart(soId))
        if (selectedTemplate === 'Invoices')
            if (invId)
                dispatch(getTemplateStart(invId))
    }, [quoteId, soId, invId, selectedTemplate])

    useEffect(() => {
        if (navbarList?.length) {
            let quote_id = navbarList?.filter(item => item.name === 'Quotes')?.[0]?._id
            setQuoteId(quote_id)
            let so_id = navbarList?.filter(item => item.name === 'Sales Orders')?.[0]?._id
            setSoId(so_id)
            let inv_id = navbarList?.filter(item => item.name === 'Invoices')?.[0]?._id
            setInvId(inv_id)
        }
    }, [navbarList])

    useEffect(() => {
        if (templateData?.updateStatus === true) {
            if (selectedTemplate === 'Quotes')
                if (quoteId)
                    dispatch(getTemplateStart(quoteId))
            if (selectedTemplate === 'Sales Orders')
                if (soId)
                    dispatch(getTemplateStart(soId))
            if (selectedTemplate === 'Invoices')
                if (invId)
                    dispatch(getTemplateStart(invId))

            toast.success(`${defaultTemplate} set as default template`, {
                autoClose: 2000,
                onClose: () => {
                    dispatch(clearMessage())
                    setDefaultTemplate('')
                }
            });
        }
        if (templateData?.updateStatus === false) {
            toast.error(templateData?.message, {
                autoClose: 3000,
                onClose: () => {
                    dispatch(resetState())
                }
            });
        }
    }, [templateData.updateStatus])

    const updateTemplate = async (data, e) => {
        const { checked } = e.target
        if (!checked) {
            let existData = templateData.data.filter((x) => x.is_default === true)
            if (!existData.length || existData?.[0]?._id === data._id) {
                toast.warn('Any one template should be set as default. An empty default is not allowed', {
                    autoClose: 3000,
                });
            }
        } else {
            setDefaultTemplate(data.templateName)
            let existData = templateData.data.filter((x) => x.is_default === true)
            if (!existData.length) {
                let payload = {
                    // "moduleId": data.moduleId,
                    // "templateName": data.templateName,
                    // "content": data.content,
                    // "templateProperties": data.templateProperties,
                    "is_default": e?.target?.checked
                }
                dispatch(updateTemplateStart({
                    id: data._id, payload: payload
                }))
            } else {
                let payloadForEnable = {
                    // "moduleId": data.moduleId,
                    // "templateName": data.templateName,
                    // "content": data.content,
                    // "templateProperties": data.templateProperties,
                    "is_default": true
                }
                dispatch(updateTemplateStart({
                    id: data._id, payload: payloadForEnable
                }))

                let payloadForDisable = {
                    // "moduleId": existData[0].moduleId,
                    // "templateName": existData[0].templateName,
                    // "content": existData[0].content,
                    // "templateProperties": existData[0].templateProperties,
                    "is_default": false
                }
                dispatch(updateTemplateStart({
                    id: existData[0]._id, payload: payloadForDisable
                }))
            }
        }
    }
    // useEffect(() => {
    //     if (selectedTemplate === 'Quotes')
    //         dispatch(getTemplateStart(quoteId))
    //     if (selectedTemplate === 'Sales Orders')
    //         dispatch(getTemplateStart(soId))
    // }, [selectedTemplate])

    // console.log('tmp dt:', templateData?.data)

    return (
        <>
            <Loader isVisible={templateData?.isLoading} />
            <Toast />
            <Card className="p-0 h-100 border-0">
                <Card.Body className="pb-0 pt-2">
                <div className="row">
                    <div className="col-3" style={{ borderRight: '1px solid #e4e4e4' }}>
                        <h5 className="fw-semibold">Templates</h5>
                        <hr />
                        <div className="setup-card">
                            <ul className="list-group list-group-flush mt-2 p-0 list-group-flush setupbox-height overflow-y-auto quote-temp-">
                                {templateType?.map((data, index) => (
                                    <li className={`list-group-item list-group-item-action border-0 ps-2 rounded-1 cursor-pointer ${activePath === data.path ? "active" : ""}`} 
                                    onClick={() => { setActivePath(data.path); setSelectedTemplate(data.key) }}>
                                        {data.key}
                                        {/* <button type="button" class="btn btn-link text-decoration-none text-body p-0 d-block w-100 text-start"
                                            >
                                            
                                        </button> */}
                                    </li>
                                ))
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-9">
                        <h5 className="fw-semibold">{selectedTemplate} Templates</h5>
                        <div className="row">
                            <div className="col-6">
                                <div className='d-flex align-items-center pb-4'>
                                    <div className="d-flex align-items-start">
                                        <div className="search-box border rounded-2">
                                            <button className="searchbutton bg-white" type="button"><FiSearch /></button>
                                            <input type="search" placeholder="Search" className="searchfield bg-white"
                                                value={value} onChange={e => setValue(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className='-d-flex -align-items-end pb-4'>
                                    <div className="-d-flex -align-items-end">
                                        <button type="button" className={`btn btn-primary btn-blue float-end`}
                                            onClick={() => navigate(Utils.getNavigationUrl(`print-template/${activePath}`))}>
                                            + New
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tbl-container rounded-table">
                            <div className="table-responsive">
                                {/* <div>
                                    <Load   er isVisible={true} isModal={true} overall={false} />
                                </div> */}
                                <table className="table table-hover shift-hour-table mb-0 hover-icon-table">
                                    <thead>
                                        <tr>
                                            {/* <th className='text-center'>
                                                <div>
                                                    <input className="form-check-input" type="checkbox" value="" aria-label="select all user"
                                                    // onChange={(e) => handleAddRemoveUser(e)}
                                                    // checked={allUsers?.allUserData?.length === shiftHoursData?.assignedUsers.length}
                                                    />
                                                </div>
                                            </th> */}
                                            <th></th>
                                            <th>Template Name</th>
                                            <th>Modified By</th>
                                            <th>Last Used</th>
                                            {orgId === '67627340b53f54575cf41de6' &&
                                                <th>Default Template</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templateData?.data?.length > 0 ?
                                            <>
                                                {templateData?.data
                                                    .filter(item => {
                                                        if (!value) return true
                                                        if (item.templateName.includes(value) || item.createdBy.firstName.includes(value) ||
                                                            item.createdBy.lastName.includes(value) || formatDateTime(item.updatedAt).includes(value)) {
                                                            return true
                                                        }
                                                    })
                                                    .map((data) => (
                                                        <tr>
                                                            {/* <td className="text-center">
                                                                <div>
                                                                    <input className="form-check-input" type="checkbox"
                                                                    // onChange={() => handleChangeAssignedUsers(data)}
                                                                    // checked={shiftHoursData.assignedUsers?.some((selectedItem) => selectedItem._id === data._id)}
                                                                    />
                                                                </div>
                                                            </td> */}
                                                            <td><FaPencil className="hover-icon cursor-pointer" style={{ fontSize: '12px' }}
                                                                onClick={() => navigate(Utils.getNavigationUrl(`print-template/${activePath}`), { state: data })} /></td>
                                                            <td>{data.templateName}</td>
                                                            <td>{data.createdBy.firstName + ' ' + data.createdBy.lastName}</td>
                                                            <td>{formatDateTime(data.updatedAt)}</td>
                                                            {orgId === '67627340b53f54575cf41de6' &&
                                                                <td>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id="custom-switch"
                                                                        checked={data?.is_default}
                                                                        onChange={(e) => updateTemplate(data, e)}
                                                                    />
                                                                </td>
                                                            }
                                                        </tr>
                                                    ))}
                                            </>
                                            :
                                            <tr>
                                                <td colSpan={6} className='text-center'>No Templates Found</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                </Card.Body>
            </Card>
        </>
    )
}
export default TemplateList